var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 32,
    viewBox: "0 0 101 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3184 25.3366H6.11072V0.389999H0V31.0531H22.3184V25.3366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0532 9.82986H38.3586V21.5037C38.3586 24.8986 36.475 26.2784 34.022 26.2784C31.547 26.2784 29.6853 24.8986 29.6853 21.5037V9.82986H23.9689V22.0075C23.9689 28.7096 28.6997 31.6007 34.022 31.6007C39.3223 31.6007 44.0532 28.7096 44.0532 22.0075V9.82986Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9874 9.2604C51.2196 9.2604 46.6859 14.0132 46.6859 20.4305C46.6859 26.8698 51.2196 31.6007 57.9874 31.6007C61.5356 31.6007 64.5143 30.177 66.5074 27.6145L62.4336 24.132C61.2289 25.4461 59.652 26.2784 57.8122 26.2784C54.8554 26.2784 52.5118 23.9787 52.5118 20.4305C52.5118 16.9043 54.8773 14.5826 57.8341 14.5826C59.6958 14.5826 61.0756 15.3273 62.3679 16.7072L66.4855 13.2685C64.5362 10.7059 61.5356 9.2604 57.9874 9.2604Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0816 9.82986H83.4965V12.1734C82.0948 10.4431 80.0578 9.2604 77.1449 9.2604C71.297 9.2604 66.8727 14.057 66.8727 20.4305C66.8727 26.8041 71.297 31.6007 77.1449 31.6007C80.0578 31.6007 82.1167 30.4179 83.4965 28.7096V31.0531H89.0816V9.82986ZM78.1962 14.5826C81.4596 14.5826 83.6717 17.0795 83.6717 20.4305C83.6717 23.7816 81.4596 26.2784 78.1962 26.2784C74.8451 26.2784 72.7206 23.6721 72.7206 20.4305C72.7206 17.189 74.8451 14.5826 78.1962 14.5826Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2861 23.1026C94.0082 23.1026 92.0151 25.0519 92.0151 27.3298C92.0151 29.6295 94.0082 31.6007 96.2861 31.6007C98.542 31.6007 100.513 29.6295 100.513 27.3298C100.513 25.0519 98.542 23.1026 96.2861 23.1026Z",
    fill: "#F96654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.8d51edff2106a235924f3576bba6fd1e.svg";
export { ForwardRef as ReactComponent };